<script setup>
import { inject, ref } from 'vue'
import { usePollStore } from '../stores/poll'
import EmojiSlider from './EmojiSlider.vue'
import PollLayout from './PollLayout.vue'

const pollParams = inject('pollParams')
const pollStore = usePollStore()

const resultValue = ref(pollParams.value || 50)
</script>

<template>
  <PollLayout>
    <div class="results-view__results">
      <div v-if="pollParams.description" class="results-view__label">
        {{ pollParams.description }}
      </div>

      <EmojiSlider
        v-model="resultValue"
        :emoji="pollParams.emoji"
        :startLabel="pollParams.startLabel"
        :stopLabel="pollParams.stopLabel"
        :disabled="true"
      />

      <div v-if="pollStore.hasVoted" class="results-view__your-vote">
        <span class="results-view__your-vote-label">Jouw stem:</span>
        <span class="results-view__your-vote-value">{{ pollStore.voteValue }}</span>
      </div>
    </div>
  </PollLayout>
</template>

<style scoped>
.results-view__results {
  padding: 2rem 0;
}

.results-view__label {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  text-align: center;
  color: #333;
}

.results-view__your-vote {
  margin-top: 2rem;
  text-align: center;
  padding: 1rem;
  background: #f5f5f5;
}

.results-view__your-vote-label {
  font-size: 0.875rem;
  color: #666;
  text-transform: uppercase;
  font-weight: 600;
  margin-right: 0.5rem;
}

.results-view__your-vote-value {
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--primary-color);
}
</style>
